import type { GenerationTileAction } from "@/components/Tiles/GenerationTile/types";
import {
  TileButtonsContainer,
  TileMuteButton,
  TilePlayButton,
} from "@/components/ui-v2";

interface VideoGenerationTileControlsProps {
  isPlaying: boolean;
  isMuted: boolean;
  disabledMuteButton: boolean;
  onAction: (event: React.MouseEvent, action: GenerationTileAction) => void;
}

export const VideoGenerationTileControls = (
  props: VideoGenerationTileControlsProps,
) => {
  const { isPlaying, isMuted, disabledMuteButton, onAction } = props;

  return (
    <TileButtonsContainer>
      <TileMuteButton
        isMuted={isMuted}
        onAction={onAction}
        disabled={disabledMuteButton}
      />
      <TilePlayButton isPlaying={isPlaying} onAction={onAction} />
    </TileButtonsContainer>
  );
};
